<template>
    <dialog id="new_question_modal" class="th-modal">
        <div class="th-modal-box p-0 rounded-[20px] min-h-[160px] xl:w-[800px] max-w-[95%] rounded-br-none flex flex-col"
             ref="modal">
            <textarea class="th-textarea th-textarea-fixed w-full h-[100px] border-none p-5" maxlength="1000"
                      v-model="questionText"
                      :placeholder="t('new_question.placeholder')">
                    </textarea>
            <div class="flex justify-end p-5">
                <button class="th-btn"
                        @click="handleSubmit"
                        :disabled="!trimedQuestionText || isLoading"
                >
                    {{ t('new_question.ask_new_question') }}
                </button>
            </div>
        </div>
    </dialog>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { onClickOutside } from '@vueuse/core';
import { onBeforeUnmount, onMounted, ref, computed } from 'vue';
import { useNavBarState } from '@eureka/nav-bar/src/composables/use-navbar-store';
import { seekSubmit } from '@eureka/new-seek-question/src/infrastructure/api-functions/index'
import { hookErrorCode } from '@eureka/services/src/custom-error-handler'
import { invokeEditionUpgrade } from '@eureka/edition-upgrade';
import { UsageAmountWhere } from '@eureka/edition-upgrade/src/constants';
import { Toast } from 'patsnap-biz';
import { E_ErrorCode } from './types/index';
import { cn, en, jp, tw } from './infrastructure/locales';

import '@patsnap-ui/icon/assets/solid/AddMedium.svg';

const { t } = useI18n({
    messages: {
        cn,
        en,
        jp,
        tw,
    },
})
const modal = ref(null)
const questionText = ref('')
const trimedQuestionText = computed(() => (questionText.value || '').trim())

const { queryList } = useNavBarState();

const isLoading = ref(false)

function close() {
    (document.querySelector('#new_question_modal') as HTMLDialogElement)?.close();
}

onClickOutside(modal, () => {
    close()
})

function handleSubmit() {
    const task = seekSubmit({
        input: trimedQuestionText.value,
    }).then(res => {
        if (res?.seek_id) {
            (document.querySelector('#new_question_modal') as HTMLDialogElement)?.close();
            window.location.href = `/page/${res.seek_id}`
            queryList();
        }
    })

    hookErrorCode(task, [E_ErrorCode.SEEK_QUESTION_LIMIT], (error) => {
        close();
        invokeEditionUpgrade(UsageAmountWhere.TECH_SEEK).then((needToast) => {
            needToast && Toast({
                message: t(`commonStatusCode.${error.data.error_code || '400'}`),
                type: 'error',
                showClose: true,
            });
        });
        return true;
    })
}

function resetInput() {
    questionText.value = ''
}

onMounted(() => {
    (document.querySelector('#new_question_modal') as HTMLDialogElement)?.addEventListener('close', resetInput);
})

onBeforeUnmount(() => {
    (document.querySelector('#new_question_modal') as HTMLDialogElement)?.removeEventListener('close', resetInput);
})
</script>
